import gql from 'graphql-tag';

const DELETE_SAVED_SEARCH = gql`
  mutation DeleteSavedSearch($params: DeleteSavedSearchParams!) {
    deleteSavedSearch(params: $params)
  }
`;

export default DELETE_SAVED_SEARCH;
